import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { fetchHeroBanners } from '../../redux/actions/bannerActions'
import { useDispatch, useSelector } from 'react-redux'
import { HeroCarousel, FeaturedBrands, Support, BrandProducts } from './components'


const Home = () => {
  const dispatch = useDispatch();
  const { heroBanners, loader } = useSelector((state) => state.banners);
  useEffect(() => {
    if (!loader && !heroBanners.length) {
      dispatch(fetchHeroBanners());
    }
  }, [loader, heroBanners.length, dispatch]);

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>Buy Dental Products Online at Best Prices | DentalStores.in</title>
        <meta name="description" content="Shop a wide range of high-quality dental products at the best prices on DentalStores.in. Get fast delivery across India, COD options, and trusted brands for dentists and clinics." />
        <meta name="keywords" content="dental products online, buy dental supplies, dental instruments India, dental materials, dental clinic supplies, dental equipment, best dental store, dental consumables, dental e-commerce, dentist essentials" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.dentalstores.in/" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.dentalstores.in/" />
        <meta property="og:title" content="Buy Dental Products Online at Best Prices | DentalStores.in" />
        <meta property="og:description" content="Shop a wide range of high-quality dental products at the best prices on DentalStores.in. Get fast delivery across India, COD options, and trusted brands for dentists and clinics." />
        <meta property="og:image" content="https://www.dentalstores.in/logo.svg" />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://www.dentalstores.in/" />
        <meta name="twitter:title" content="Buy Dental Products Online at Best Prices | DentalStores.in" />
        <meta name="twitter:description" content="Shop a wide range of high-quality dental products at the best prices on DentalStores.in. Get fast delivery across India, COD options, and trusted brands for dentists and clinics." />
        <meta name="twitter:image" content="https://www.dentalstores.in/logo.svg" />
      </Helmet>
      
      <HeroCarousel />
      <div className='section__container'>
        <Support />
        <FeaturedBrands />
      </div>
        <BrandProducts title="Dentsply Sirona" brandId="dentsply-sirona" />
        <BrandProducts title="Shofu" brandId="shofu" />
        <BrandProducts title="GC" brandId="gc" />
        <BrandProducts title="Mani" brandId="mani" />
        <BrandProducts title="Ivoclar" brandId="ivoclar" />
        <BrandProducts title="Synerheal" brandId="synerheal" />
        <BrandProducts title="Cologenesis" brandId="cologenesis" />
        <BrandProducts title="DPI" brandId="dpi" />
        <BrandProducts title="Advanced-Biotech" brandId="advanced-biotech" />
        <BrandProducts title="EVA" brandId="eva" />
        <BrandProducts title="GoDent" brandId="godent" />
    </>
  );
};

export default Home;
